import actions from './actions.js'
import mutations from './mutations.js'
import getters from './getters.js'

const state = {
  success_notifications: [],
  success_notification_time: 4000,
  time_reduce: 20,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}